function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.date.to-json.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.function.bind.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url-search-params.js";
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { Constants as CONSTANTS } from "./commons/list.constants.class";
import Api from "./commons/api.class";
import Sort from "./sort.class";
import SwiperSlider from "integration-web-core--socle/js/assets/modules/_swiperSlider.class";
import Filters from "./filters.class";
import PedagogicalFilters from "./pedagogicalFilters.class";
import SelectedFilters from "./selectedFilters.class";
import { Pagination } from "@mozaic-ds/freemarker/js/modules/_pagination";
import FiltersLayer from "./filters-layer.class";
var List = /*#__PURE__*/function () {
  function List(config) {
    _classCallCheck(this, List);
    try {
      if (config.event === undefined || config.event === null) throw new Error("Paramètre event est obligatoire!");
      this.config = config;
      this.event = this.config.event;
      this.dataForApi = {};
      this.container = document.querySelector(".".concat(CONSTANTS.PRODUCT_LIST_SELECTORS.CONTAINER));
      this.api = new Api(this.config.url);
      this.isProductsListEmpty = false;
      this.filtersInstance = null;
      this.pedagoFiltersInstance = null;
      this.paginationInstance = {};
      this.sortInstance = null;
      this.uriParameters = new URLSearchParams(window.location.search);

      // listen the event of filters
      this._listenEvent(this);
      _addTrackingEventOnProducts.call(this);
      // Initialize filters
      _initFilters.call(this);
      // Initialize pedagogical filters
      _initPedagoFilters.call(this);
      // Init pedagogical filters
      _initSwiperPedagoFilters();
      // Initialize Sorting
      _initSorting.call(this);
      // Initialize selected filters (tags above list elements )
      _initSelectedFilters.call(this);
      // Initialize pagination
      _initPagination.call(this);
    } catch (err) {
      console.error("Error : ", err);
    }
  }
  return _createClass(List, [{
    key: "_listenEvent",
    value: function _listenEvent() {
      document.addEventListener(this.event.key, _update.bind(this));
    }
  }]);
}();
export default List;
function _initFilters() {
  this.filtersInstance = new Filters(this.config);
  new FiltersLayer();
}
function _initSorting() {
  this.sortInstance = new Sort(this);
}
function _initPedagoFilters() {
  this.pedagoFiltersInstance = new PedagogicalFilters(this);
}
function _initSelectedFilters() {
  new SelectedFilters(this);
}
function _initPagination() {
  var _this = this;
  this.isProductsListEmpty = document.querySelector(".".concat(CONSTANTS.PRODUCT_LIST_SELECTORS.EMPTY_LIST_ELM)) !== null && document.querySelector(".".concat(CONSTANTS.PRODUCT_LIST_SELECTORS.EMPTY_LIST_ELM)).dataset.emptyList !== undefined;
  if (this.isProductsListEmpty === false) {
    this.paginationInstance = new Pagination("".concat(CONSTANTS.PAGINATIONS.SELECTOR), function () {
      _paginate.call(_this);
    });
  }
}
function _update(evt) {
  var _this2 = this;
  if (evt.detail.filters.sorting !== undefined && evt.detail.action === CONSTANTS.ACTION.SORT) {
    this.dataForApi.sort = evt.detail.filters.sorting;
    this.paginationInstance.currentPage = 1;
    this.dataForApi.p = 1;
  }
  if (evt.detail.action === CONSTANTS.PEDAGOGICAL_FILTERS.ACTIONS.VALIDATE || evt.detail.action === CONSTANTS.PEDAGOGICAL_FILTERS.ACTIONS.REMOVE_PEDAGOGICAL_FILTER_VALUE) {
    this.paginationInstance.currentPage = this.dataForApi.p = 1;
    if (Object.keys(evt.detail.filters.pedagogicalFilters).length > 0) {
      this.dataForApi.pedagogicalFilters = this.pedagoFiltersInstance.format(evt.detail.filters.pedagogicalFilters).applieds;
    } else {
      delete this.dataForApi["pedagogicalFilters"];
    }
    if (evt.detail.action === CONSTANTS.PEDAGOGICAL_FILTERS.ACTIONS.VALIDATE) this.dataForApi.mqm = JSON.stringify({
      currentQuestionCode: this.pedagoFiltersInstance.currentPedagogicalFilterCode,
      action: CONSTANTS.PEDAGOGICAL_FILTERS.ACTIONS.VALIDATE
    });
  }
  if (evt.detail.lastSelectedFilter !== undefined) {
    this.config.lastSelectedFilter = evt.detail.lastSelectedFilter;
  }
  if (evt.detail.filters.p !== undefined && evt.detail.action === CONSTANTS.ACTION.PAGINATE) {
    this.dataForApi.p = evt.detail.filters.p;
  }
  //on recharge la p avec les filtres et on aplique directement un tri
  // on doit récupere touts les valuers des filtres sélectionné
  if (Object.keys(this.filtersInstance.selectedFilters).length > 0 && evt.detail.action !== CONSTANTS.ACTION.FILTER) {
    this.dataForApi.filters = this.filtersInstance.format(this.filtersInstance.selectedFilters).applieds;
  }
  if (Object.keys(this.pedagoFiltersInstance.validatedPedagogicalFilters).length > 0 && evt.detail.action !== CONSTANTS.PEDAGOGICAL_FILTERS.ACTIONS.VALIDATE && evt.detail.action !== CONSTANTS.PEDAGOGICAL_FILTERS.ACTIONS.REMOVE_PEDAGOGICAL_FILTER_VALUE) {
    this.dataForApi.pedagogicalFilters = this.pedagoFiltersInstance.format(this.pedagoFiltersInstance.validatedPedagogicalFilters).applieds;
  }
  if (evt.detail.filters !== undefined && evt.detail.action === CONSTANTS.ACTION.FILTER) {
    this.paginationInstance.currentPage = this.dataForApi.p = 1;
    if (Object.keys(evt.detail.filters).length > 0) {
      this.dataForApi.filters = evt.detail.filters.applieds;
    } else {
      delete this.dataForApi["filters"];
    }
  }
  if (evt.detail.action === CONSTANTS.ACTION.RESET_FILTERS) {
    delete this.dataForApi["filters"];
    _resetPedagogicalFilters.call(this);
  }
  if (evt.detail.action === CONSTANTS.PEDAGOGICAL_FILTERS.ACTIONS.RESET) {
    _resetPedagogicalFilters.call(this);
  }
  if (evt.detail.action === CONSTANTS.PEDAGOGICAL_FILTERS.ACTIONS.SKIP || evt.detail.action === CONSTANTS.PEDAGOGICAL_FILTERS.ACTIONS.BACK) {
    var isMqmFinished = _isMqmFinished.call(this);
    this.dataForApi.mqm = JSON.stringify({
      currentQuestionCode: this.pedagoFiltersInstance.currentPedagogicalFilterCode,
      action: evt.detail.action,
      finished: isMqmFinished
    });
  }
  _rewriteUrl.bind(this)();
  this.api.get({
    data: this.dataForApi,
    success: function success(data) {
      _displayResponseInView.call(_this2, data, evt);
    },
    error: function error() {
      console.log("error api");
    }
  });
}
function _resetPedagogicalFilters() {
  delete this.dataForApi["pedagogicalFilters"];
  delete this.dataForApi["mqm"];
}
function _displayResponseInView(data, event) {
  _parseData.call(this, data);
  _initFilters.call(this);
  this.pedagoFiltersInstance = new PedagogicalFilters(this.config);
  _initSwiperPedagoFilters();
  _initSorting.call(this);
  _initSelectedFilters.call(this.config);
  _initPagination.call(this);
  _focusLastSelectedFilter.call(this);
  if (_shouldScrollToTop.call(this, event)) {
    _scrollToTop.call(this);
  }
  lm.lazyload.observe();
  // Pagination event refresh tc vars
  var _tcVarsPaginationEvt = new CustomEvent("refreshTcVars", {
    detail: {
      callee: "PAGINATION"
    }
  });
  document.dispatchEvent(_tcVarsPaginationEvt);
}
function _focusLastSelectedFilter() {
  var lastSelectedFilterFocusTarget = this.filtersInstance.form.querySelector("#".concat(this.config.lastSelectedFilterFocusTarget));
  if (lastSelectedFilterFocusTarget) lastSelectedFilterFocusTarget.focus();
}
function _isMqmFinished() {
  var pedagogicalFilterForm = this.container.querySelector(".".concat(CONSTANTS.PEDAGOGICAL_FILTERS.SELECTOR));
  return pedagogicalFilterForm && pedagogicalFilterForm.dataset.isFinished === "true";
}
function _shouldScrollToTop(event) {
  var isValidatingLastMqmQuestion = _isMqmFinished.call(this) && event.detail.action === CONSTANTS.PEDAGOGICAL_FILTERS.ACTIONS.VALIDATE;
  return event.detail.action !== CONSTANTS.PEDAGOGICAL_FILTERS.ACTIONS.SKIP && event.detail.action !== CONSTANTS.PEDAGOGICAL_FILTERS.ACTIONS.BACK && event.detail.action !== CONSTANTS.PEDAGOGICAL_FILTERS.ACTIONS.RESET && (event.detail.action !== CONSTANTS.PEDAGOGICAL_FILTERS.ACTIONS.VALIDATE || isValidatingLastMqmQuestion);
}
function _parseData(data) {
  var parser = new DOMParser();
  var parsedHtml = parser.parseFromString(data, "text/html");
  var filtersHtml = parsedHtml.querySelector(".".concat(CONSTANTS.FILTERS_FORM_CONTAINER_SELECTOR)).outerHTML;
  document.querySelector(".".concat(CONSTANTS.FILTERS_FORM_CONTAINER_SELECTOR)).innerHTML = filtersHtml;
  var listHtml = parsedHtml.querySelector(".".concat(CONSTANTS.PRODUCT_LIST_SELECTORS.CONTENT)).outerHTML;
  this.container.querySelector(".".concat(CONSTANTS.PRODUCT_LIST_SELECTORS.CONTENT)).innerHTML = listHtml;
  var closeFiltersLayerButtonLabel = parsedHtml.querySelector(".".concat(CONSTANTS.FILTERS_LAYER_CLOSE_BUTTON)).innerHTML;
  document.querySelector(".".concat(CONSTANTS.FILTERS_LAYER_CLOSE_BUTTON)).innerHTML = closeFiltersLayerButtonLabel;
}
function _rewriteUrl() {
  var queryParams = {
    p: "".concat(this.paginationInstance.currentPage)
  };
  if (this.dataForApi.filters) {
    queryParams.filters = this.dataForApi.filters;
  }
  if (this.dataForApi.pedagogicalFilters) {
    queryParams.pedagogicalFilters = this.dataForApi.pedagogicalFilters;
  }
  if (this.dataForApi.sort) {
    queryParams.sort = this.dataForApi.sort;
  }
  if (this.dataForApi.mqm) {
    queryParams.mqm = this.dataForApi.mqm;
  }
  var urlSearchParams = new URLSearchParams(queryParams).toString();
  window.history.pushState({}, window.tc_vars.page_name, "?".concat(urlSearchParams));
}
function _paginate() {
  var data = {};
  data[this.event.dataKey] = {
    p: this.paginationInstance.currentPage
  };
  this.event.target(_objectSpread({
    action: CONSTANTS.ACTION.PAGINATE
  }, data));
}
function _scrollToTop() {
  var htmlElem = document.querySelector("html");
  var bodyElem = document.querySelector("body");
  htmlElem.style.overflowX = "auto";
  bodyElem.style.overflowX = "auto";
  var sortingPosition = this.sortInstance.sortingElement.getBoundingClientRect().bottom + window.scrollY;
  window.scrollTo({
    top: sortingPosition,
    left: 0,
    behavior: "smooth"
  });
}
function _initSwiperPedagoFilters() {
  var pedagoFilterSelector = document.querySelector(".".concat(CONSTANTS.SWIPER_PEDAGOGICAL_FILTERS.SELECTOR));
  if (pedagoFilterSelector) {
    new SwiperSlider(".".concat(CONSTANTS.SWIPER_PEDAGOGICAL_FILTERS.SELECTOR));
  }
}
function _addTrackingEventOnProducts() {
  if (this.uriParameters.has("src") && this.uriParameters.has("query")) {
    var productsList = document.querySelector(".".concat(CONSTANTS.PRODUCT_LIST_SELECTORS.PRODUCTS));
    if (productsList) {
      productsList.addEventListener("click", _submitProductTracking.bind(this));
    }
  }
}
function _submitProductTracking(event) {
  var requestBody = _buildTrackingBody.call(this, event.target);
  if (requestBody) {
    fetch(window.location.origin + "/search-product/services/log/category", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(requestBody)
    });
  }
}
function _buildTrackingBody(target) {
  var numberOfProducts = document.querySelector(".km-sorting__numbers");
  var item = target.closest("li");
  if (item !== null && item !== void 0 && item.classList.contains("l-resultsList__item") && item.tagName === "LI" && item.hasAttribute("data-position") && item.hasAttribute("data-reflm")) {
    return {
      query: this.uriParameters.get("query"),
      source: this.uriParameters.get("src"),
      numberOfProducts: numberOfProducts ? numberOfProducts.innerHTML : null,
      page: this.paginationInstance.currentPage,
      clickedSku: item.dataset.reflm,
      clickedSkuPosition: item.dataset.position,
      limit: document.getElementById("component-productfamilypage").dataset.numberofproducts
    };
  }
}